<template>
	<div class="customRadio">
    <input
    type="radio"
    class="radio"
    :class="{
      'disabled': disabled
    }"
    :id="id"
    :name="name"
    :check="checked"
    :disabled="disabled"
    @click.prevent="$emit('handleCheck')"
    />
		<label class="radio" :for="id">
				<span>{{ labelText }}</span>
		</label>
  </div>
</template>

<script>
export default {
	name: 'FormRadio',
	props: {
		id: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		labelText: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		checked: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
		};
	},
	methods: {
	}
};
</script>

<style lang="scss" scoped>
input {
  position: absolute;
  top: auto;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px); /* IE 6/7 */
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  white-space: nowrap;
}
label {
  position: relative;
  display: inline-block;
  padding-top: 3px;
  font-size: 14px;
  cursor: pointer;
}
label:before {
  content: '';
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: -3px 8px 0 0;
  vertical-align: middle;
  background: url(../../assets/images/set_form.png) no-repeat 0 0;
  background-size: 50px;
  cursor: pointer;
}
input:checked + label:before,
input[check="true"] + label:before {
  background-position: 0 -50px;
}
input:disabled + label {
  opacity: 0.3;
}
</style>
